<h5 mat-dialog-title class="mat-subtitle-1">Delete file</h5>
<div mat-dialog-content class="mat-subtitle-2 lh-16">
  Would you like to delete cat.jpeg?
</div>
<div mat-dialog-actions class="p-24 p-t-0">
  <button mat-stroked-button color="warn" mat-dialog-close>No</button>
  <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>
    Ok
  </button>
</div>
